import React from "react";
import {
  Route,
  Routes as ReactRoutes,
  Navigate,
  useLocation,
} from "react-router-dom";
import SurveyRoutes from "../modules/survey/application/router";
import SpaceRoutes from "../modules/spaces/application/router";
import routesPaths from "./routesPaths";

const PreserveQueryRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  return <Navigate replace to={`${to}${location.search}`} />;
};

const Routes: React.FC = () => (
  <ReactRoutes>
    <Route
      path={routesPaths.root}
      element={<PreserveQueryRedirect to={routesPaths.spaces} />}
    />
    {SurveyRoutes}
    {SpaceRoutes}
    <Route path='*' element={<PreserveQueryRedirect to={routesPaths.root} />} />
  </ReactRoutes>
);

export default Routes;
